import React, { useContext, useEffect, useState } from "react";
import "datatables.net";
import DataPerPage from "../../CommonComponents/Pagination/DataPerPage";
import SearchComponent from "../../CommonComponents/SearchComponent/SearchComponent";
import CustomTable from "../../CommonComponents/Table/CustomTable";
import Button from "../../Elements/Button";
import AddCustomizationModal from "./AddCustomizationModal";
import HandleUiModal from "./HandleUiModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import UserInfoContext from "../../../utils/userInfoContext";
import { networkService } from "../../config/axios";
import AdminPagination from "../../CommonComponents/Pagination/AdminPagination";
import Breadcrumb from "../../CommonComponents/BreadCrumb/BreadCrumb";
import "../Admin/admin.css";

const Customizations = () => {
  const { profileData } = useContext(UserInfoContext);
  const [openModal, setOpenModal] = useState(false);
  const [openClickModel, setOpenClickModel] = useState(false);
  const [customizationData, setCustomizationData] = useState({});
  const [customizationId, setCustomizationId] = useState(null);
  const [customizations, setCustomizations] = useState([]);
  const [currentPageData, setCurrentPageData] = useState([]);
  const [dataPerPage, setDataPerPage] = useState(10);
  const totalData = customizations?.length;

  const handlePageChange = (pageNumber) => {
    const indexOfLastData = pageNumber * dataPerPage;
    const indexOfFirstData = indexOfLastData - dataPerPage;
    setCurrentPageData(
      customizations?.slice(indexOfFirstData, indexOfLastData)
    );
  };

  useEffect(() => {
    const fetchCustomizations = async () => {
      const response = await networkService("customizations.json", "GET");
      setCustomizations([...response.data?.customizations]);
    };
    fetchCustomizations();
  }, [openModal, openClickModel]);

  useEffect(() => {
    handlePageChange(1);
  }, [customizations]);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const columns = React.useMemo(() => {
    return [
      {
        Header: "User Name",
        accessor: "user_name",
        Cell: () => <>{profileData?.name}</>,
      },
      {
        Header: "Message",
        accessor: "message",
      },
      {
        Header: "Status",
        accessor: "approved",
        Cell: ({ row: { original } }) => (
          <>{original?.approved ? "Approved" : "Requested"}</>
        ),
      },
      {
        Header: "Actions",
        accessor: "action",
        Cell: ({ row }) => (
          <div className="d-flex align-items-center">
            <img
              src="/icons/edit.svg"
              alt=""
              className="cursor-pointer admin-customization-action-icon"
              onClick={() => {
                setCustomizationData(row?.original);
                setOpenModal(true);
              }}
              role="button"
            />
          </div>
        ),
      },
    ];
  }, [currentPageData, profileData]);

  return (
    <>
      {openModal && (
        <AddCustomizationModal
          openModal={openModal}
          closeModal={handleCloseModal}
          customizationData={customizationData}
          setCustomizationId={setCustomizationId}
          setOpenClickModel={setOpenClickModel}
        />
      )}
      {openClickModel && (
        <HandleUiModal
          openModal={openClickModel}
          closeModal={() => {
            setOpenClickModel(false)
            setCustomizationData({});
          }}
          customizationId={customizationId}
          isEdit={customizationData?.id ? true : false}
        />
      )}

      <div className="admin-module">
        <div className="admin-customization-page admin-content">
          <Breadcrumb string="Consent Modal Change Requests" />

          <div className="container admin-customization-container">
            <div className="mb-4 show-select1 d-flex admin-customization-header">
              <div className="admin-customization-controls admin-customization-search-group">
                {totalData > dataPerPage && (
                  <DataPerPage
                    dataPerPage={dataPerPage}
                    setDataPerPage={setDataPerPage}
                  />
                )}
                <div className="admin-customization-search-input-wrap">
                  <SearchComponent
                    data={customizations}
                    setCurrentPageData={setCurrentPageData}
                    placeholder="Search here"
                  />
                </div>
                <button
                  type="button"
                  className="admin-customization-search-btn"
                  aria-label="Search"
                >
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </button>
              </div>

              <Button
                classList="success"
                addonClass="admin-customization-cta"
                text="+ Request a Change"
                onClick={() => {
                  setOpenModal(true);
                  setCustomizationData({})
                }}
                type="button"
                aria-label="Request a change"
              />
            </div>

            <div className="top-parent admin-customization-table-wrapper">
              {customizations && (
                <CustomTable
                  data={currentPageData}
                  showFilters={false}
                  columnData={columns}
                />
              )}
            </div>

            {totalData > dataPerPage && (
              <AdminPagination
                dataPerPage={dataPerPage}
                totalData={totalData}
                onPageChange={handlePageChange}
                showRange={true}
                previousLabel="‹ Previous"
                nextLabel="Next ›"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Customizations;
